import { useMedia } from 'react-use';

export const useTouchScreen = () =>
  useMedia('(hover: none) and (pointer: coarse)', false);
